import {
    ADD_LOCAL_PARTY_MASTER_UPLOAD_SUCCESS, ADD_LOCAL_PARTY_MASTER_UPLOAD_FAILURE, ADD_LOCAL_PARTY_MASTER_UPLOAD_FAILURE_FILE, LOCAL_PARTY_MASTER_TEMPLATE_SUCCESS, LOCAL_PARTY_MASTER_TEMPLATE_FAILURE,
    LOCAL_PARTY_MASTER_DATA_EXCEL_SUCCESS,
    LOCAL_PARTY_MASTER_DATA_EXCEL_FAILURE,
} from './action';
const initialState = {
    addLocalPartyMasterUploadSuccess: [],
    addLocalPartyMasterUploadFailure: [],
    addLocalPartyMasterUploadFailureFile: null,
    localPartyMasterListSuccess: null,
    localPartyMasterListFailure: null
}

const localPartyMasterReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_LOCAL_PARTY_MASTER_UPLOAD_SUCCESS:
            return state = {
                ...state,
                addLocalPartyMasterUploadSuccess: action
            }
        case ADD_LOCAL_PARTY_MASTER_UPLOAD_FAILURE:
            return state = {
                ...state,
                addLocalPartyMasterUploadFailure: action
            }
        case ADD_LOCAL_PARTY_MASTER_UPLOAD_FAILURE_FILE:
            return state = {
                ...state,
                addLocalPartyMasterUploadFailureFile: action.data
            }

            case LOCAL_PARTY_MASTER_TEMPLATE_SUCCESS:
                return {
                    ...state,
                    localPartyMasterTemplateSuccess: action.data
                }

        case LOCAL_PARTY_MASTER_TEMPLATE_FAILURE:
            return {
                ...state,
                localPartyMasterTemplateFailure: action.data
            }

            case LOCAL_PARTY_MASTER_DATA_EXCEL_SUCCESS:
                return {
                    ...state,
                    localPartyMasterDataExcelSuccess: action.data
                }

        case LOCAL_PARTY_MASTER_DATA_EXCEL_FAILURE:
            return {
                ...state,
                localPartyMasterDataExcelFailure: action.data
            }

        case 'LOCAL_PARTY_MASTER_LIST_SUCCESS':
            return {
                ...state,
                localPartyMasterListSuccess: action.data
            };

        case 'LOCAL_PARTY_MASTER_LIST_FAILURE':
            return {
                ...state,
                localPartyMasterListFailure: action.data
            };

        default: return state
    }
}
export default localPartyMasterReducer;
